module.exports = __webpack_public_path__ + "img/56.483162f4.jpg";